import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppService } from 'src/@core/services/app.service';
import { FunnelService } from './funnel.service';
import { formatCredits, formatPercent, FunnelMetricsResponse, FunnelMove, readFunnel } from './funnel.logic';

const STRIP_DAYS = 30;

/**
 * A slim funnel summary for the top of the project page: leads reached per
 * stage, credits per move, and cost per goal. Shown only when the project has
 * a funnel, and it never blocks the page: if the numbers cannot load it hides.
 */
@Component({
  selector: 'hour4u-admin-funnel-strip',
  templateUrl: './funnel-strip.component.html',
  styleUrls: ['./funnel-strip.component.scss']
})
export class FunnelStripComponent implements OnInit, OnChanges {
  @Input() projectDetails: any;
  @Output() openFunnel = new EventEmitter<void>();

  profile = this.appService.getCurrentAccount();
  data: FunnelMetricsResponse | null = null;
  isLoading = false;
  failed = false;
  readonly days = STRIP_DAYS;
  readonly formatCredits = formatCredits;
  readonly formatPercent = formatPercent;
  private requestId = 0;

  constructor(private funnelService: FunnelService, private appService: AppService) {}

  ngOnInit() {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['projectDetails'];
    if (change && !change.firstChange) {
      const before = change.previousValue;
      const after = change.currentValue;
      if (!before || !after || before.project_id !== after.project_id ||
        JSON.stringify(before.funnel_config) !== JSON.stringify(after.funnel_config)) {
        this.load();
      }
    }
  }

  get hasFunnel(): boolean {
    return !!readFunnel(this.projectDetails);
  }

  get visible(): boolean {
    return this.hasFunnel && !this.failed && (this.isLoading || !!(this.data && this.data.summary));
  }

  moveInto(index: number): FunnelMove | null {
    const moves = this.data && this.data.moves ? this.data.moves : [];
    return index > 0 && moves[index - 1] ? moves[index - 1] : null;
  }

  trackById(_: number, stage: { id: string }) {
    return stage.id;
  }

  load() {
    this.data = null;
    this.failed = false;
    if (!this.hasFunnel || !this.projectDetails.project_id || !this.profile || !this.profile.entity) {
      return;
    }
    const id = ++this.requestId;
    this.isLoading = true;
    this.funnelService.getMetricsCached(this.profile.entity.id, this.projectDetails.project_id, STRIP_DAYS).subscribe(
      (res) => {
        if (id !== this.requestId) { return; }
        this.data = res;
        this.isLoading = false;
      },
      () => {
        if (id !== this.requestId) { return; }
        this.failed = true;
        this.isLoading = false;
      }
    );
  }
}
